import React from "react";
import PropTypes from "prop-types";
import IconButton from "material-ui/IconButton";
import FirstPageIcon from "material-ui-icons/FirstPage";
import KeyboardArrowLeft from "material-ui-icons/KeyboardArrowLeft";
import KeyboardArrowRight from "material-ui-icons/KeyboardArrowRight";
import LastPageIcon from "material-ui-icons/LastPage";

function TablePagination({ onChangePage, page, total_pages }) {
  return (
    <div>
      <span>
        {total_pages > 0 ? page : 0} of {total_pages}
      </span>
      <IconButton
        onClick={() => onChangePage(1)}
        aria-label="First Page"
        disabled={page <= 1}
      >
        <FirstPageIcon />
      </IconButton>
      <IconButton
        onClick={() => onChangePage(page - 1)}
        aria-label="Previous Page"
        disabled={page <= 1}
      >
        <KeyboardArrowLeft />
      </IconButton>
      <IconButton
        onClick={() => onChangePage(page + 1)}
        aria-label="Next Page"
        disabled={page >= total_pages}
      >
        <KeyboardArrowRight />
      </IconButton>
      <IconButton
        onClick={() => onChangePage(total_pages)}
        aria-label="Last Page"
        disabled={page >= total_pages}
      >
        <LastPageIcon />
      </IconButton>
    </div>
  );
}

TablePagination.defaultProps = {};

TablePagination.propTypes = {};

export default TablePagination;



// WEBPACK FOOTER //
// ./src/components/Pagination/TablePagination.jsx